import compose from 'lodash/flowRight'
import {connect} from 'react-redux'
import * as Redux from 'redux'

import type {AppDispatch} from '../../../../actions/types'
import {withUpdateResults} from '../../../../contexts/update'
import type {State} from '../../../../reducers/types'
import {lookDeeper, gotoLastPage} from '../Pager.actions'
import {withPagerHelper} from '../Pager.container'
import {getPager} from '../Pager.selectors'
import {hasItemsOnPage} from '../Pager.utils'

import type {ReduxOwnProps, StateProps} from './PagerWarning.types'

const mapStateToProps = (state: State, props: ReduxOwnProps): StateProps => {
  const {group, isLoading} = props
  const currentPage = Number(props.page) || 1
  const pager = getPager(state, group)
  const {total = 0, hasMore, lookupLimit, lookupLimitWarning, pageSize} = pager
  const noItemsOnPageWarning = total > 0 && !hasItemsOnPage(currentPage, pager)
  return {
    show: props.isShow === true || (isLoading !== true && total === 0),
    currentPage,
    pageSize,
    total,
    hasMore,
    lookupLimit,
    lookupLimitWarning,
    noItemsOnPageWarning,
  }
}

const mapDispatchToProps = (dispatch: AppDispatch, props: ReduxOwnProps) => {
  const {updateResults, group} = props
  return Redux.bindActionCreators(
    {
      lookDeeper: lookDeeper(updateResults),
      gotoLastPage: gotoLastPage(updateResults, group),
    },
    dispatch,
  )
}

export default compose(
  withUpdateResults(),
  withPagerHelper,
  connect(mapStateToProps, mapDispatchToProps),
)
